import { render } from "./ModalGaleria.vue?vue&type=template&id=35aa1e2d&scoped=true&ts=true"
import script from "./ModalGaleria.vue?vue&type=script&lang=ts"
export * from "./ModalGaleria.vue?vue&type=script&lang=ts"

import "./ModalGaleria.vue?vue&type=style&index=0&id=35aa1e2d&scoped=true&lang=css"
import "./ModalGaleria.vue?vue&type=style&index=1&id=35aa1e2d&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35aa1e2d"]])

export default __exports__